import React from 'react';
import axios from 'axios';
import InputEditorWrapper from 'app/mixins/InputEditorWrapper.jsx';
import InputBehaviorComponent from 'app/components/EditorComponents/InputBehaviorComponent.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import { Breakpoint } from 'react-socks';

class ReviewPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            preview: null,
            previewError: null,
            fetchingPreview: true,
            showLightbox: false
        };

        this.openLightbox = this.openLightbox.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        let constants = this.props.app.config.constants,
            previewRequest = {};

        document.addEventListener('keyup', this.onKeyUp);

        if (this.props.input.type !== undefined && this.props.input.type) {
            let input = this.props.input
            previewRequest.type = input.type;

            switch (input.type) {
                case constants.INPUT_TYPE_FEED:
                    previewRequest.inputId = input.inputId;
                    break;

                case constants.INPUT_TYPE_FACEBOOK_PAGE:
                case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
                case constants.INPUT_TYPE_TIKTOK:
                case constants.INPUT_TYPE_YOUTUBE:
                    if (input.scID !== undefined && input.scID) {
                        previewRequest.scID = input.scID;
                    } else if (input.inputId !== undefined && input.inputId) {
                        previewRequest.inputId = input.inputId;
                    } else if (input.credID !== undefined && input.credID) {
                        previewRequest.credID = input.credID;
                    }

                    if (input.attrs.playlistID !== undefined) {
                        previewRequest.playlistID = input.attrs.playlistID;
                    }
                    break;

                default:
                    break;
            }

            if (input.type === constants.INPUT_TYPE_YOUTUBE) {
                previewRequest.maxHeight = Math.round(window.innerHeight * .5);
            }

            axios({
                url: `${this.props.app.config.apiUrl}/input/preview`,
                data: previewRequest,
                headers: { "Content-type": "application/json" },
                method: 'POST',
                withCredentials: true,
                responseType: 'json'
            })
            .then((response) => {
                let data = response.data;
                this.setState({
                    preview: data,
                    fetchingPreview: false
                });

            })
            .catch((error) => {
                this.setState({
                    previewError: error.data,
                    fetchingPreview: false
                });
            });
        }

    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    openLightbox(isOpen) {
        this.setState({
            showLightbox: isOpen
        });
    }

    onKeyUp(e) {
        if (e.key === 'Escape') {
            if (this.state.showLightbox) {
                this.setState({
                    showLightbox: false
                });
            }
        }
    }

    render() {
        let constants = this.props.app.config.constants,
            input = this.props.input,
            iconService = constants.POST_SVC_FEED,
            previewData = {
                icon: '',
                name: '',
                media: '',
                date: '',
                title: '',
                content: ''
            },
            imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl;

        if (this.state.preview !== null) {
            previewData.date = this.state.preview.itemDate;
            previewData.title = this.state.preview.itemTitle;
            previewData.body = this.state.preview.itemBody;

            switch (input.type) {
                case constants.INPUT_TYPE_FEED:
                    previewData.icon = this.state.preview.feedImage;
                    previewData.name = this.state.preview.feedTitle;
                    previewData.media = this.state.preview.itemImage;
                    break;

                case constants.INPUT_TYPE_FACEBOOK_PAGE:
                case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
                    previewData.icon = this.state.preview.avatarUrl;
                    previewData.name = this.state.preview.displayName;
                    previewData.media = this.state.preview.mediaLink;

                    if (this.state.preview.mediaType !== undefined && this.state.preview.mediaType.match(/video/i)) {
                        previewData.mediaType = 'video';
                    }
                    if (input.type === constants.INPUT_TYPE_FACEBOOK_PAGE) {
                        iconService = constants.POST_SVC_FACEBOOK;
                    } else {
                        iconService = constants.POST_SVC_INSTAGRAM_BUSINESS;
                    }
                    break;

                case constants.INPUT_TYPE_TIKTOK:
                    iconService = constants.POST_SVC_TIKTOK;
                    previewData.icon = this.state.preview.avatarUrl;
                    previewData.name = this.state.preview.displayName;
                    previewData.media = this.state.preview.imageLink;
                    break;

                case constants.INPUT_TYPE_YOUTUBE:
                    iconService = constants.POST_SVC_YOUTUBE;
                    previewData.icon = this.state.preview.avatarUrl;
                    previewData.name = this.state.preview.displayName;
                    previewData.media = this.state.preview.imageLink;
                    previewData.body = this.state.preview.description;
                    previewData.embedHtml = this.state.preview.embedHtml;
                    break;

                default:
                    break;
            }
        }

        let previewElement = null;
        if (this.state.preview === null && !this.state.fetchingPreview) {
            previewElement = (
                <div className="no-preview">
                    We can't generate a preview of this input.
                </div>
            );
        } else if (this.state.fetchingPreview) {
            previewElement = (
                <div className="no-preview">
                    Loading preview <i className="fa fa-spinner fa-spin"></i>
                </div>
            );
        } else {
            let previewContent = null;
            if (previewData.body === undefined && previewData.media === undefined && previewData.title === undefined) {
                previewContent = (
                     <div className="no-preview bordered">
                        There are no recent items here.<br/>
                        We'll post the next new item added.
                    </div>
                );
            } else {
                previewContent = (
                    <div className="input-content">
                        {previewData.media ? (
                            <div className="input-media" onClick={() => {
                                this.openLightbox(true);
                            }}>
                                {previewData.mediaType !== undefined && previewData.mediaType === 'video' ? (
                                    <div>
                                        <video>
                                            <source src={previewData.media}/>
                                        </video>
                                        <div className="play-overlay">
                                            <img src={`${imgPath}/misc/play.svg`} width="50" height="50"/>
                                        </div>
                                    </div>
                                ) : (
                                    <img src={previewData.media} onError={(e) => { e.target.style.display = 'none'; }}/>
                                )}
                                <div className="expand-button">
                                    <img src={`${imgPath}/misc/expand.svg`} width="32" height="32"/>
                                </div>
                            </div>
                        ) : null}
                        {previewData.title ? (
                            <div className="input-post-title">
                                {previewData.title}
                            </div>
                        ) : null}
                        {previewData.date ? (
                            <div className="input-date">
                                {moment(previewData.date).fromNow()}
                            </div>
                        ) : null }
                        {previewData.body ? (
                            <div className="input-copy">
                                {previewData.body}
                            </div>
                        ) : null}
                    </div>
                );
            }
            previewElement = (
                <div>
                    <div className="input-title">
                        {previewData.icon ? (
                            <div className="input-icon">
                                <SocialAvatar
                                    social={{
                                        psID: iconService,
                                        src: previewData.icon
                                    }}
                                    compact={true}/>
                            </div>
                        ) : null}
                        <div className="input-identifiers">
                            <div className="input-name">{previewData.name}</div>
                            <div className="display-type">Most recent item</div>
                        </div>
                    </div>
                    {previewContent}
                </div>
            );
        }

        let lightbox = null;
        if (this.state.showLightbox) {
            let media = null;
            if (previewData.embedHtml !== undefined) {
                media = (<div dangerouslySetInnerHTML={{__html: previewData.embedHtml}}/>);
            } else if (previewData.mediaType !== undefined && previewData.mediaType === 'video') {
                media = (
                    <video controls>
                        <source src={previewData.media}/>
                    </video>
                );
            } else {
                media = (<img src={previewData.media} onError={(e) => { e.target.style.display = 'none'; }}/>)
            }

            lightbox = (
                <div className="review-lightbox">
                    <div className="close-lightbox" onClick={() => {
                        this.openLightbox(false);
                    }}>
                        <i className="icon ion-close-circled"/>
                    </div>
                    {media}
                </div>
            );

        }

        return (
            <div className="final-review">
                {lightbox}
                <Breakpoint desktop only>
                    <div className="review-panel">
                        <div className="review-options">
                            <div className="editor-panel">
                                <form>
                                    <fieldset>
                                        <legend>Input Name</legend>
                                        <ErrorModule
                                            app={this.props.app}
                                            keys={[constants.INPUT_VALIDATE]}
                                            render={(state) => {
                                                return (
                                                    <FieldError field="name" errors={state.errors}/>
                                                );
                                            }}/>
                                        <UncontrolledTextInput
                                            className="text-input large"
                                            defaultValue={input.name}
                                            onChange={this.props.changeHandler}
                                            data-field={this.props.statePath + ".name"}/>
                                    </fieldset>
                                    <InputBehaviorComponent
                                        {...this.props}
                                        input={input}
                                        statePath={this.props.statePath}
                                        styledSelectClass="full" />
                                </form>
                            </div>
                        </div>
                        <div className="input-preview">
                            {previewElement}
                        </div>
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="review-panel">
                        <div className="input-preview">
                            {previewElement}
                        </div>
                        <div className="review-options">
                            <div className="editor-panel">
                                <form>
                                    <fieldset>
                                        <legend>Input Name</legend>
                                        <ErrorModule
                                            app={this.props.app}
                                            keys={[constants.INPUT_VALIDATE]}
                                            render={(state) => {
                                                return (
                                                    <FieldError field="name" errors={state.errors}/>
                                                );
                                            }}/>
                                        <UncontrolledTextInput
                                            className="text-input large"
                                            defaultValue={input.name}
                                            onChange={this.props.changeHandler}
                                            data-field={this.props.statePath + ".name"}/>
                                    </fieldset>
                                    <InputBehaviorComponent
                                        {...this.props}
                                        input={input}
                                        statePath={this.props.statePath}
                                        styledSelectClass="full" />
                                </form>
                            </div>
                        </div>
                    </div>
                </Breakpoint>

            </div>
        )
    }
}

ReviewPanel.displayName = "ReviewPanel";

export default ReviewPanel;
